export default class customCarousel {
    /**
     * set variables and initialize carousel
     */
    constructor($node) {
        this.$node = $node;
        this.$slidePosition = 0;
        this.$horizontalPosition = 0;
        this.$prevArrow;
        this.$nextArrow;
        this.$carouselWrapper = this.$node.querySelector('div.carousel-wrapper');
        if (!this.$carouselWrapper) return
        this.$lastSlide = this.getLastNonEmptyChild(this.$carouselWrapper);
        if (!this.$lastSlide) return
        this.$carouselWidth = this.$carouselWrapper.offsetWidth;
        this._initNavigation();
    }

    /**
     * append arrow buttons to carousel and set click listeners
     */
    _initNavigation() {
        const $wrap = document.createElement('div')
        $wrap.classList.add('slide-navigation')
        $wrap.classList.add('nav-arrows')

        const $prev = document.createElement('div')
        $prev.classList.add('nav-arrow')
        $prev.classList.add('arrow-prev')
        $prev.classList.add('disabled')
        $prev.addEventListener('click', this.slidePrev.bind(this))
        this.$prevArrow = $prev;

        $wrap.append($prev)

        const $next = document.createElement('div')
        $next.classList.add('nav-arrow')
        $next.classList.add('arrow-next')
        $next.addEventListener('click', this.slideNext.bind(this))
        this.$nextArrow = $next;

        $wrap.append($next)
        this.$node.append($wrap)

        const $carouselHeight = this.$carouselWrapper.clientHeight;
        $wrap.style.bottom = `${$carouselHeight + 32}px`;

        return this
    }

    /**
     * set distance to move carousel when prev button is clicked
     */
    slidePrev() {
        this.$slidePosition--;
        this.$horizontalPosition += (this.$carouselWidth + 20);
        this.navigateCarousel();
    }

    /**
     * set distance to move carousel when next button is clicked
     */
    slideNext() {
        this.$slidePosition++;
        this.$horizontalPosition -= (this.$carouselWidth + 20);
        this.navigateCarousel();
    }

    /**
     * slide the carousel upon clicking the nav button
     */
    navigateCarousel() {
        for (const slide of this.$carouselWrapper.childNodes) {

            if (slide.nodeType === Node.ELEMENT_NODE && slide.textContent.trim() !== '') {
                slide.style.transform = `translateX(${this.$horizontalPosition}px)`;
            }
        }
        // wait for carousel to finish sliding to check if buttons need to be disabled
        setTimeout(() => {
            this.manageArrows();
        }, 600);
    }

    /**
     * check if arrows need to be disabled
     */
    manageArrows() {
        if (this.$slidePosition < 1) {
            this.$prevArrow.classList.add('disabled');
        } else {
            this.$prevArrow.classList.remove('disabled');
        }
        
        if (this.$lastSlide.getBoundingClientRect().left < this.$carouselWrapper.getBoundingClientRect().right) {
            this.$nextArrow.classList.add('disabled');
        } else {
            this.$nextArrow.classList.remove('disabled');
        }
    }

    /**
     * retreive last slide of carousel. To check its position compared to 
     * carousel wrapper
     */
    getLastNonEmptyChild(parentElement) {
        let children = parentElement.childNodes;

        for (let i = children.length - 1; i >= 0; i--) {
            let child = children[i];

            if (child.nodeType === Node.ELEMENT_NODE && child.textContent.trim() !== '') {
                return child;
            }
        }

        return null;
    }
}